import Container from "@/components/Container";
import MedicalReportPdf from "./MedicalReportPdf";
import InvitationForm from "../Shared/InvitationForm";
import CollapsibleList from "@/components/Collapsible/CollapsibleList";
import { ROLES } from "@/data/interfaces/RolesEnum";
import UserActionPlanForm from "./UserActionPlanForm";

const listItems = [
  {
    id: 1,
    label: "Pakviesti pacientą",
    description: (
      <InvitationForm
        role={ROLES.USER}
        title="Pakviesti pacientą"
        successMessage="Pakvietimas išsiųstas pacientui"
      />
    ),
  },
  {
    id: 2,
    label: "Medical Report PDF",
    description: <MedicalReportPdf />,
  },
  {
    id: 3,
    label: "Sukurti veiksmų planus",
    description: <UserActionPlanForm />,
  },
];

const DoctorPanel = () => {
  return (
    <Container className="mt-8 mb-8 px-4">
      <h2 className="text-ink mb-4 text-2xl font-semibold">Daktaras</h2>

      <CollapsibleList data={listItems} />
    </Container>
  );
};

export default DoctorPanel;
